// src/pages/History/MiddleAges/ByzantineEmpire.jsx

import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/Middle_Ages_-_Byzantine_Empire.png';

function HistoryPageByzantine() {
  return (
    <TopicPage
      topicKey="Byzantine Empire"
      title="History: Byzantine Empire"
      backgroundImage={bg}
      startRoute="/History-Byzantine-Go"
      scrollLabels={[
        "Justinian and Theodora",
        "Orthodox Christianity",
        "Fall of Constantinople",
      ]}
                    backRoute="/history-Middle-Ages"   // go back to the Middle-Ages menu
  backLabel="← Return to topics"
  backButtonClassName="journey-button special"
  backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageByzantine;   